module.exports = __webpack_public_path__ + "static/media/shogun-sport-hero.9e3dd54c.jpg";